<span *ngIf="!picture" [attr.data-letters]="letters" [class.large]="largeAvatar"></span>
<img *ngIf="picture" [src]="picture" alt="avatar" class="profile-avatar">
